import { constructionFields } from "./construction";
import { existingPropertyFields } from "./existing-property";

export const proposedOverviewFields = {
	construction: constructionFields,
	"existing property": existingPropertyFields,
};
